import React from 'react'
import styles from './HeroBannerSection.module.css'

/*
  Replace HERO_IMAGE with your Cloudflare R2 / CDN link.
  You can also pass it in as a prop: <HeroBannerSection backgroundImage="..." />
*/
const HERO_IMAGE =
  'https://pub-f369b33409cf4a599883d7bec60d1538.r2.dev/112.png'

const HeroBannerSection = ({ backgroundImage = HERO_IMAGE }) => {
  return (
    <section
      id="home"
      className={styles.hero}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className={styles.overlay} />

      <div className={styles.content}>
        <h1 className={styles.heading}>
          Your strategic partner for
          <br />
          <span className={styles.headingFade}>extraordinary events</span>
        </h1>

        <p className={styles.subtext}>
          We design one-of-a-kind experiences that inspire, engage, and
          <br />
          deliver measurable impact for brands across India.
        </p>

        <div className={styles.actions}>
          <a href="#contact" className={styles.btnPrimary}>
            <span>Schedule a Call</span>
            <span className={styles.arrowCircle}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2"
                  strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </a>
          <a href="#services" className={styles.btnGhost}>
            View Capabilities
          </a>
        </div>
      </div>

      {/* Bottom-right scroll cue */}
      <a href="#about" className={styles.explore}>
        <span className={styles.exploreText}>Start Exploring</span>
        <svg className={styles.exploreIcon} width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 5v14M6 13l6 6 6-6" stroke="currentColor" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span className={styles.exploreLine} />
      </a>
    </section>
  )
}

export default HeroBannerSection